/* eslint-disable max-len */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TenantService } from 'src/app/services/api/tenant.service';
import { translate } from '@jsverse/transloco';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Subscription } from 'rxjs';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { ClipboardService } from 'ngx-clipboard';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { UrlService } from 'src/app/services/util/url.service';
import { Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Constants } from 'src/app/models/constants';
import { SystemService } from 'src/app/services/api/system.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Attributes, Datazone, Permissions } from 'src/app/models/principal/permission';
import { DeploymentClass } from 'src/app/models/instance-class';
import { AgentStatus } from 'src/app/models/agents/agent-status';
import { Instance } from 'src/app/models/instance/instance';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { isSolutionVersion } from 'src/app/services/util/utils';
import { AVAILABLE_STATE_ICON } from 'src/app/models/instance/instance';
import { AvailabilityStatus } from 'src/app/models/availability-status';


const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.TENANT_READ,
    action: Permissions.TENANT_READ
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_LIVE,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_NONPII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_NONPII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_PII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_PII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  }
];

@Component({
    selector: 'app-shared-services',
    templateUrl: './shared-services.component.html',
    styleUrls: ['./shared-services.component.scss'],
    standalone: false
})
export class SharedServicesComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  @ViewChild(MatSort, { static: true }) sort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  PermissionKeys = PermissionKeys;
  Constants = Constants;
  permissionsMap: { [key: string]: boolean };
  RouterSegments = RouterSegments;
  DeployStatus = DeployStatus;
  breadcrumbItems: BreadcrumbItem[];

  tenant: string;
  showSpinner: any;
  searchSolutionText: any;
  dropdownsList: any = [];
  dashboardLink: any;
  pageSize: number;
  pageNumber = 1;

  paginationSize = 10;
  pageIndex = 0;
  showPagination = true;
  sortInfo: any;
  tenantList: any;
  tenantId: any;
  filteredColumns: any;
  clearData: boolean;
  selectedDefaultFilter: any;
  data: any;
  isLoading: boolean;
  copy = false;
  sharedServicesLink: any;
  showNoSharedServices: any;
  subscriptionIdPii: any;
  subscriptionNamePii: any;
  subDataZonePii: any;
  subscriptionIdNonPii: any;
  subscriptionNameNonPii: any;
  subDataZoneNonPii: any;
  accountIdNonProdPii: any;
  accountNameNonProdPii: any;
  accountEmailNonProdPii: any;
  accDataZoneNonProdPii: any;
  accountIdNonPii: any;
  accountNameNonPii: any;
  accountEmailNonPii: any;
  accDataZoneNonPii: any;
  accountIdProdPii: any;
  accountNameProdPii: any;
  accountEmailProdPii: any;
  accDataZoneProdPii: any;
  DeployStatusPii: boolean;
  DeployStatusNonPii: boolean;
  DeployStatusNonProdPii: boolean;
  DeployStatusProdPii: boolean;
  piiData = [];
  nonPiiData = [];
  DeployIngressPii: boolean;
  DeployServicesPii: boolean;
  DeployIngressNonPii: boolean;
  DeployServicesNonPii: boolean;
  serviceNewPii = [];
  servicePii = [];
  serviceNonPii = [];
  tenantDetailsData: any;
  accountData: any;
  isDataLoading: any;
  servicePiiFalseCount: number;
  serviceNonPiiFalseCount: number;
  serviceNewPiiFalseCount: number;
  deployNonPiiCertificateCompleted: boolean;
  versions: any;
  azureTssSolutionId: any;
  awsTssSolutionId: any;
  solutionVersionSearch: any;
  selectedValue: any;
  currentSolutionVersionId: string;
  currentVersion: any;
  solutionName: any;
  certificationData: any;
  dataLoading: boolean;
  dataSource: any;
  newPiiData: any;
  DeployServicesNewPii: boolean;
  serviceNewNonPiiFalseCount: number;
  solutionSearchLoading = true;
  showCard: boolean;
  instanceClass = DeploymentClass;
  AgentStatus = AgentStatus;
  devInstance: any;
  testDataZoneInstances: any[];
  piiDataZoneInstances: any[];
  nonpiiStartStop: boolean;
  piiStartStop: boolean;
  instanceList: any;
  activeSubscriptionId: any;
  solutionVersions: any;
  copyValues = [{idCopy:false},{idCopy:false},{idCopy:false},{idCopy:false},{idCopy:false},{idCopy:false},{idCopy:false},{idCopy:false},{idCopy:false},{idCopy:false},{idCopy:false}]
  copyGitValue = [{gitCopy:false},{gitCopy:false},{gitCopy:false},{gitCopy:false},{gitCopy:false}]
  copyKeycloak=[{copy:false},{copy:false},{copy:false},{copy:false},{copy:false},{copy:false},{copy:false},{copy:false},{copy:false},{copy:false}]
  searchValue:any;
  isAWS: boolean;
  hasSecondaryRegion: boolean;
  solutionComponents :any = [];
  defaultComponents = [{value: 'Temn Monitor' ,response: 'temnmonitor', selected: false, default: false}, {value: 'SFTP' , response: 'sftp', selected: false, default: false}, {value: 'External MQ' ,response: 'external_messaging', selected: false, default: false}];
  isLowerVersion : boolean;
  optionalComponentCount : number;
  isComponentLoading: boolean;
  AVAILABLE_STATE_ICON = AVAILABLE_STATE_ICON;
  instanceAvailabilityMap: { [id: string]: string } = {};
  AvailabilityStatus = AvailabilityStatus;

  readonly inprogressStatus = [DeployStatus.DEPLOYING, DeployStatus.TERMINATING, DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.TESTING,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.OPERATION_INPROGRESS, DeployStatus.INPROGRESS];

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.INPROGRESS];


  constructor(private route: ActivatedRoute, private authService: AuthService, private instanceService: InstancesService,
    private sidenavService: SidenavService, private toastrService: CustomToastrService, private tenantService: TenantService,
    public dateTimeFormatService: DateTimeFormatService, private solutionsService: SolutionsService, private toastrErrorService: ToastrErrorService, private dialog: MatDialog, private clipboardApi: ClipboardService,
    private urlService: UrlService, private router: Router,private permissionsService: PermissionsService, private systemService: SystemService) {

  }

  ngOnInit(): void {
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.sidenavService.tenantSelectedMenu = 'LEFT_SIDE_NAV.SHARED_SERVICES';
    this.tenant = this.authService.principal.provider;
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.TENANT_READ]) {
      this.router.navigate(['/', this.tenant, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.DeployStatusNonPii = false;
    this.DeployStatusPii = false;
    this.DeployStatusNonProdPii = false;
    this.DeployStatusProdPii = false;
    this.tenantId = this.route.snapshot.params.id;
    if(this.tenantId) {
      this.isLoading = true;
      this.loadData(this.tenantId, true);
      this.loadInstances();
    }
    this.dashboardLink = ({ label: translate('LEFT_SIDE_NAV.TENANT_ONBOARDING') });
    this.sharedServicesLink = ({ label: translate('LEFT_SIDE_NAV.SHARED_SERVICES'), url: ['shared-services'] });
    this.dropdownsList = [
      {
        title: 'Tenant',
        placeholder: translate('INSTANCE_LIST.SELECT_TENANT'),
        key: 'tenant',
        options: []
      },
    ];

    this.clearData = true;
    this.getTenants();
    this.showNoSharedServices = true;
  }

  getAvailabilityState(instanceId: string): string {
    return this.instanceAvailabilityMap?.[instanceId];
  }

  isDeployDisabled(instanceId: string): boolean {
    const availabilityState = this.getAvailabilityState(instanceId) as AvailabilityStatus;
    return [
      AvailabilityStatus.STARTING,
      AvailabilityStatus.STOPPING,
      AvailabilityStatus.STOPPED
    ].includes(availabilityState);
  }

  /**
   * Getting a tenant List to be displayed in filter removing all the external tenants.
   */
  getTenants(): void {
    this.dropdownsList[0].options = [];
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data) {
          data = data.filter(value => value.managementType !== 'external' && value.tenantId !== 'temenos.com');
          this.tenantList = [...new Set(data.map(item => item.tenantId).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
          this.tenantList.forEach((value) => {
            this.dropdownsList[0].options.push({ value, selected: false });
          });
        }
      });
  }

  loadData(tenantId, initialLoad : boolean): void {
     if (initialLoad) {
    this.subscriptionIdPii = '';
    this.subscriptionIdNonPii = '';
    this.accountIdNonPii = '';
    this.accountIdNonProdPii = '';
    this.accountIdProdPii = '';
    }
    this.isDataLoading = initialLoad;
    this.tenantService.getTenantDetails(tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.tenantDetailsData = data;
      if (this.tenantDetailsData?.sharedServices?.nonpii?.messaging?.clientCert &&
        this.tenantDetailsData?.sharedServices?.nonpii?.messaging?.clientCert?.find(item => item.status === 'added')) {
          this.tenantDetailsData.sharedServices.nonpii.isActiveCert = true;
      }

      if (this.tenantDetailsData?.sharedServices?.nonprod?.messaging?.clientCert &&
        this.tenantDetailsData?.sharedServices?.nonprod?.messaging?.clientCert?.find(item => item.status === 'added')) {
          this.tenantDetailsData.sharedServices.nonprod.isActiveCert = true;
      }

      if (this.tenantDetailsData?.sharedServices?.pii?.messaging?.clientCert &&
        this.tenantDetailsData?.sharedServices?.pii?.messaging?.clientCert?.find(item => item.status === 'added')) {
          this.tenantDetailsData.sharedServices.pii.isActiveCert = true;
      }
      if (this.tenantDetailsData?.sharedServices?.prod?.messaging?.clientCert &&
        this.tenantDetailsData?.sharedServices?.prod?.messaging?.clientCert?.find(item => item.status === 'added')) {
          this.tenantDetailsData.sharedServices.prod.isActiveCert = true;
      }
      if(this.tenantDetailsData?.parameters?.hasSecondaryRegion && (this.tenantDetailsData?.parameters?.hasSecondaryRegion === 'true' || this.tenantDetailsData?.parameters?.hasSecondaryRegion === true)) {
          this.hasSecondaryRegion = true;
        } else if(!this.tenantDetailsData?.parameters?.hasSecondaryRegion) {
          this.hasSecondaryRegion = true;
        } else {
          this.hasSecondaryRegion = false;
        }
      if(this.tenantDetailsData?.parameters?.instanceStopStart?.length > 0) {
        this.tenantDetailsData?.parameters?.instanceStopStart.forEach(data => {
          if(data === 'nonpii') {
            this.nonpiiStartStop = true;
          }
          if(data === 'pii') {
            this.piiStartStop = true;
          }
        })
      }
      if(data?.cloudProvider === 'AWS' || data?.targetCloud === 'AWS') {
      if (this.tenantDetailsData?.sharedServices?.prod?.status === DeployStatus.SUCCESS){
        this.tenantDetailsData.sharedServices.prod.status = DeployStatus.DEPLOYED;
      }
      if (this.tenantDetailsData?.sharedServices?.pii?.status === DeployStatus.SUCCESS){
        this.tenantDetailsData.sharedServices.pii.status = DeployStatus.DEPLOYED;
      }
    }
      this.tenantService.getTenantCertificate(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        if(response) {
          this.certificationData = response;
          this.certificationData.filter((item) => {
              if(item.type === 'nonpii'  || item.type === 'nonprod') {
                this.deployNonPiiCertificateCompleted = true;
              }
            });
        }
      })
      this.systemService.getSystem().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      if(response) {
                this.azureTssSolutionId = response.azureTssSolutionId;
                this.awsTssSolutionId = response.awsTssSolutionId;
                if(data?.cloudProvider === 'AWS' || data?.targetCloud === 'AWS') {
                  this.solutionVersionSearch = this.awsTssSolutionId;
                } else if(data?.cloudProvider === 'Azure' || data?.targetCloud === 'Azure'){
                  this.solutionVersionSearch = this.azureTssSolutionId;
                }
              }
              if(this.solutionVersionSearch) {
                this.solutionsService.getSolutionById(this.solutionVersionSearch).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
                  this.solutionName = data.name;
                })
                this.solutionsService.getSolutionVersions(this.solutionVersionSearch).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
                  if(data) {
                    this.versions = [];
                    this.prepareComponents(data);
                    const serviceObj = this.tenantDetailsData?.sharedServices ? Object.keys(this.tenantDetailsData?.sharedServices) : undefined;
                    this.isComponentLoading  = serviceObj?.length ? true : false;
                    if(serviceObj?.length) {
                      serviceObj.forEach(item => {
                        const availableService = this.tenantDetailsData?.sharedServices?.[item];
                        if (availableService && availableService?.instanceId) {
                          this.instanceService.getInstanceById(this.tenantDetailsData?.sharedServices?.[item]?.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(instanceData => {
                            this.tenantDetailsData.sharedServices[item].instanceDetails = instanceData;
                            this.currentSolutionVersionId = instanceData.solutionVersionId;
                            data.forEach((value) => {
                              if(value.id === this.currentSolutionVersionId) {
                                this.currentVersion = value.version;
                                this.modifyComponents(this.currentVersion);
                                this.checkforViewDetails();
                                this.defaultTemnMonitor(this.currentVersion);
                                this.applyTenantOptionalComponents();
                                this.isComponentLoading = false;
                                if(this.currentVersion.split('.')[0].length === 1) {
                                  this.showCard = true;
                                } else {
                                  this.showCard = false;
                                }
                                this.solutionSearchLoading = true;
                              } else {
                                this.solutionSearchLoading = false;
                                if (!this.versions.includes(value.version)) {
                                this.versions.push(value.version);
                                }
                                this.solutionVersions = this.versions;
                              }
                            });
                          });

                        } else {
                          data.forEach((value) => {
                            this.solutionSearchLoading = false;
                            this.versions = [];
                            this.solutionVersions = [];
                            this.versions.push(value.version);
                            this.solutionVersions = this.versions;
                          });
                        }
                      });
                    } else {
                      data.forEach((value) => {
                        this.solutionSearchLoading = false;
                        this.versions.push(value.version);
                        this.solutionVersions = this.versions;
                      });
                    }
                  }
                });
              }
            });
      const gitlabUrl = this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl;
      if (gitlabUrl && gitlabUrl.endsWith('.')) {
        this.tenantDetailsData.sharedServices.nonprod.gitlabUrl = gitlabUrl.substring(0, gitlabUrl.length - 1);
      }
      const newGitlabUrl = this.tenantDetailsData?.sharedServices?.nonpii?.gitlabUrl;
      if (newGitlabUrl && newGitlabUrl.endsWith('.')) {
        this.tenantDetailsData.sharedServices.nonpii.gitlabUrl = newGitlabUrl.substring(0, newGitlabUrl.length - 1);
      }
      const piiGitlabUrl = this.tenantDetailsData?.sharedServices?.pii?.gitlabUrl;
      if (piiGitlabUrl && piiGitlabUrl.endsWith('.')) {
        this.tenantDetailsData.sharedServices.pii.gitlabUrl = piiGitlabUrl.substring(0, piiGitlabUrl.length - 1);
      }
      const gitlabUrlProd = this.tenantDetailsData?.sharedServices?.prod?.gitlabUrl;
      if (gitlabUrlProd && gitlabUrlProd.endsWith('.')) {
        this.tenantDetailsData.sharedServices.prod.gitlabUrl = gitlabUrlProd.substring(0, gitlabUrlProd.length - 1);
      }
      const keycloakUrl = this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl;
      if (keycloakUrl && keycloakUrl.endsWith('.')) {
        this.tenantDetailsData.sharedServices.nonprod.keycloakUrl = keycloakUrl.substring(0, keycloakUrl.length - 1);
      }
      const newKeycloakUrl = this.tenantDetailsData?.sharedServices?.nonpii?.keycloakUrl;
      if (newKeycloakUrl && newKeycloakUrl.endsWith('.')) {
        this.tenantDetailsData.sharedServices.nonpii.keycloakUrl = newKeycloakUrl.substring(0, newKeycloakUrl.length - 1);
      }
      const piiKeycloakUrl = this.tenantDetailsData?.sharedServices?.pii?.keycloakUrl;
      if (piiKeycloakUrl && piiKeycloakUrl.endsWith('.')) {
        this.tenantDetailsData.sharedServices.pii.keycloakUrl = piiKeycloakUrl.substring(0, piiKeycloakUrl.length - 1);
      }
      const keycloakUrlProd = this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl;
      if (keycloakUrlProd && keycloakUrlProd.endsWith('.')) {
        this.tenantDetailsData.sharedServices.prod.keycloakUrl = keycloakUrlProd.substring(0, keycloakUrlProd.length - 1);
      }
      if (this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl && this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.prod.keycloakUrl = this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl;
      } else if(this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl){
        this.tenantDetailsData.sharedServices.prod.keycloakUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl;
      }
      if (this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl && this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.nonprod.keycloakUrl = this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl;
      } else if(this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl){
        this.tenantDetailsData.sharedServices.nonprod.keycloakUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl;
      }
      if (this.tenantDetailsData?.sharedServices?.nonpii?.keycloakUrl && this.tenantDetailsData?.sharedServices?.nonpii?.keycloakUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.nonpii.keycloakUrl = this.tenantDetailsData?.sharedServices?.nonpii?.keycloakUrl;
      } else if(this.tenantDetailsData?.sharedServices?.nonpii?.keycloakUrl){
        this.tenantDetailsData.sharedServices.nonpii.keycloakUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.nonpii?.keycloakUrl;
      }
      if (this.tenantDetailsData?.sharedServices?.pii?.keycloakUrl && this.tenantDetailsData?.sharedServices?.pii?.keycloakUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.pii.keycloakUrl = this.tenantDetailsData?.sharedServices?.pii?.keycloakUrl;
      } else if(this.tenantDetailsData?.sharedServices?.pii?.keycloakUrl){
        this.tenantDetailsData.sharedServices.pii.keycloakUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.pii?.keycloakUrl;
      }
      if (this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl && this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.nonprod.gitlabUrl = this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl;
      } else if(this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl){
        this.tenantDetailsData.sharedServices.nonprod.gitlabUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl;
      }

      if (this.tenantDetailsData?.sharedServices?.nonpii?.gitlabUrl && this.tenantDetailsData?.sharedServices?.nonpii?.gitlabUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.nonpii.gitlabUrl = this.tenantDetailsData?.sharedServices?.nonpii?.gitlabUrl;
      } else if(this.tenantDetailsData?.sharedServices?.nonpii?.gitlabUrl){
        this.tenantDetailsData.sharedServices.nonpii.gitlabUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.nonpii?.gitlabUrl;
      }
      this.isDataLoading = false; 
      if (this.tenantDetailsData?.sharedServices?.pii?.gitlabUrl && this.tenantDetailsData?.sharedServices?.pii?.gitlabUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.pii.gitlabUrl = this.tenantDetailsData?.sharedServices?.pii?.gitlabUrl;
      } else if(this.tenantDetailsData?.sharedServices?.pii?.gitlabUrl){
        this.tenantDetailsData.sharedServices.pii.gitlabUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.pii?.gitlabUrl;
      }
      if (this.tenantDetailsData?.sharedServices?.prod?.optionalComponents?.length > 0){
        this.servicePii.filter((item) => {
          this.tenantDetailsData?.sharedServices?.prod?.optionalComponents.filter((component) => {
          if(item.response === component )
              item.default = true;
          });
        });
        this.servicePiiFalseCount = this.servicePii.filter(item => item.default === false).length;
      }
    });
    this.tenantService.getTenantAccountDetails(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (data) {
          this.accountData = data;
          this.accountData?.forEach(item => {
            if(item?.azureDetails) {
              if(item?.dataZone === SubscriptionTypes.PII) {
                this.subscriptionIdPii = item?.azureDetails?.subscriptionId;
                this.activeSubscriptionId = this.subscriptionIdPii;
              } else {
                this.subscriptionIdNonPii = item?.azureDetails?.subscriptionId;
                if (!this.activeSubscriptionId) {
                  this.activeSubscriptionId = this.subscriptionIdNonPii;
                }
              }
            }
            if(item?.awsDetails) {
              if(item?.dataZone === SubscriptionTypes.NONPII) {
                this.accountIdNonPii = item?.awsDetails?.accountId;
              } else if(item?.dataZone === SubscriptionTypes.AWS_NON_PROD_PII){
                this.accountIdNonProdPii = item?.awsDetails?.accountId;
              } else if(item?.dataZone === SubscriptionTypes.AWS_PROD_PII){
                this.accountIdProdPii = item?.awsDetails?.accountId;
              }
            }
          });
        }
      });
   }

   loadInstances(): void {
    const obj = {
      tenantId: this.tenantId
    };
    this.instanceService.getInstances(obj)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data?.total > 10) {
          const instanceObj = {
            size: data.total,
            tenantId: this.tenantId
          };
          this.instanceService.getInstances(instanceObj)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(instances => {
              this.instanceList = instances.data;
              this.instanceAvailabilityMap = {};
              this.instanceList.forEach(instance => {
                this.instanceAvailabilityMap[instance.id] =
                  instance.availabilityState;
              });
          });
        } else {
          this.instanceList = data.data;
          this.instanceAvailabilityMap = {};
          this.instanceList.forEach(instance => {
            this.instanceAvailabilityMap[instance.id] =
              instance.availabilityState;
          });
        }
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

   selectionChanged(value): void {
    this.modifyComponents(value);
    this.modifyOptionalComponent(value);
    this.selectedValue = value;
    this.defaultTemnMonitor(value);
    if(this.selectedValue.split('.')[0].length === 1) {
      this.showCard = true;
    } else {
      this.showCard = false;
    }
  }
  
  // Temn monitor is defaulted only from 202601 release
  defaultTemnMonitor(value) {
    const numericVersion = Number(value.split('.')[0]); 
    const limit = 202601;
    this.serviceNewPii.forEach(item => {
      if (item.value === 'Temn Monitor') {
        if (numericVersion >= limit) {
          item.selected = true;
          item.default = true;
        } else {
          item.selected = false;
          item.default = false;
        }
      }
    });
    this.sortServiceComponents(this.serviceNewPii);
  }

   onCopyId(data,field?, position?): void {
    field ? field==='id'? this.copyValues[position].idCopy = true : field==='git'? this.copyGitValue[position].gitCopy = true : this.copyKeycloak[position].copy = true :'' ;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
        field ? field==='id'? this.copyValues[position].idCopy = false : field==='git'? this.copyGitValue[position].gitCopy = false : this.copyKeycloak[position].copy = false :'' ;
    }, 500);
  }

   closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }

  selectOptionsServicePii(data): void {
    this.servicePii.filter((item) => {
      if (item.value === data) {
        if(item.selected) {
          item.selected = false;
          const pii = this.piiData.indexOf(data);
          if (pii > -1) {
            this.piiData.splice(pii, 1);
          }
        } else {
          item.selected = true;
          this.piiData.push(item.value);
        }
      }
    });
  }

  selectOptionsServiceNewPii(data): void {
    this.serviceNewPii.filter((item) => {
      if (item.value === data) {
        if(item.selected) {
          item.selected = false;
          const pii = this.newPiiData.indexOf(data);
          if (pii > -1) {
            this.newPiiData.splice(pii, 1);
          }
        } else {
          item.selected = true;
          this.newPiiData?.push(item.value);
        }
      }
    });
  }

  selectOptionsServiceNonPii(data): void {
    this.serviceNonPii.filter((item) => {
      if (item.value === data) {
        if(item.selected) {
          item.selected = false;
          const nonPii = this.nonPiiData.indexOf(data);
          if (nonPii > -1) {
            this.nonPiiData.splice(nonPii, 1);
          }
        } else {
          item.selected = true;
          this.nonPiiData.push(item.value);
        }
      }
    });
  }

  /**
   * On clicking Deploy button, shared services will get deployed in the specific environment.
   * @params - Environment value to be deployed.
   */
  onClickDeployService(value): void {
    let proceedFurther;
    const isAWS = this.tenantDetailsData?.cloudProvider === 'AWS' || this.tenantDetailsData?.targetCloud === 'AWS';
    const version = this.selectedValue || this.currentVersion;
    if(value === SubscriptionTypes.PROD || value === SubscriptionTypes.PII || value === SubscriptionTypes.NEW_PII || value === SubscriptionTypes.AWS_NONPROD_PII || value === SubscriptionTypes.NON_PII ) {
      proceedFurther = this.deployNonPiiCertificateCompleted;
    }
    if(isAWS) {
      proceedFurther = true;
    }
    if(!this.hasSecondaryRegion && value === SubscriptionTypes.PII && this.tenantDetailsData?.sharedServices?.prod?.status !== DeployStatus.DEPLOYED) {
      this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        confirmButtonText: translate('TENANT_FORM.CONFIRM_BUTTON_REGION'),
        secondaryRegionWarn: true,
        secondaryMsg: true
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
          if(proceedFurther) {
          this.confirmCall(value, isAWS, version);
          }
        }
      })
    } else {
      if(proceedFurther) {
      this.confirmCall(value, isAWS, version);
      }
    }
  }

  confirmCall(value, isAWS, version){
    const message = (value === SubscriptionTypes.PII ? translate('TENANT_DETAILS.SHARED_MESSAGE_PROD') : (value === SubscriptionTypes.AWS_NONPROD_PII ? translate('TENANT_DETAILS.SHARED_MESSAGE_NON_PROD') : (value === SubscriptionTypes.NON_PII ? translate('TENANT_DETAILS.SHARED_MESSAGE_NON_PII') :translate('TENANT_DETAILS.SHARED_MESSAGE_PII'))));
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('TENANT_DETAILS.EDGE_TITLE'),
        message: message,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
        this.isComponentLoading = true;
        if(value === SubscriptionTypes.PII) {
          this.DeployServicesPii = true;
          const component  = [];
          this.servicePii.forEach(element => {
           if(element.selected === true) {
            component.push(element.response);
           }
          });
          let piiData: any;
          if(isAWS){
            piiData = {
              tenantId: this.tenantId,
              version,
              dataZone: 'prod',
            }
            if (!this.showCard) {
              piiData.components = component;
            }
          }else{
          piiData = {
            tenantId: this.tenantId,
            version,
            ...(this.showCard ? { prod: true } : { dataZone: 'prod' }),
            components: component
            };
          }
          this.tenantService.postTenantSharedServiceDetails(piiData)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(pii => {
            this.servicePii.forEach(element => {
              if(element.selected === true) {
               component.push(element.response);
              }
             });
             this.loadData(this.tenantId,false);
            setTimeout(() => {
              const title = translate('ERROR_DIALOG.PROD_SHARED_SERVICES');
              const message = translate('ERROR_DIALOG.DEPLOYMENT_REQUEST');
              this.toastrService.successMessage(message, title);
            }, 500);
            this.loadInstances();
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.SHARED_PROD_FAILED'),
            description: errorMessage
          }})
            this.isComponentLoading = false;
            this.DeployServicesPii = false;
          });
          this.DeployServicesPii = false;
        } else if(value === SubscriptionTypes.AWS_NONPROD_PII) {
          this.DeployServicesNonPii = true;
          const component  = [];
          component.push();
          this.serviceNonPii.forEach(element => {
            if(element.selected === true) {
             component.push(element.response);
            }
           });
           let nonPiiData: any;
           if (isAWS) {
            nonPiiData = {
              tenantId: this.tenantId,
              version,
              dataZone: 'pii'
            };
            if (!this.showCard) {
              nonPiiData.components = component;
            }
          } else {
            nonPiiData = {
              tenantId: this.tenantId,
              version,
              ...(this.showCard ? { nonprod: true } : { dataZone: 'nonpii' }),
              components: component
            };
          }
          this.tenantService.postTenantSharedServiceDetails(nonPiiData)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(nonPii => {
            this.serviceNonPii.forEach(element => {
              if(element.selected === true) {
               component.push(element.response);
              }
             });
             this.loadData(this.tenantId,false);
            setTimeout(() => {
              const title = translate('ERROR_DIALOG.NON_PROD_SHARED_SERVICES');
              const message = translate('ERROR_DIALOG.DEPLOYMENT_REQUEST');
              this.toastrService.successMessage(message, title);
            }, 500);
            this.loadInstances();
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.SHARED_NON_PII_FAILED'),
            description: errorMessage
          }})
            this.isComponentLoading = false;
            this.DeployServicesNonPii = false;
          });
        }else if(value === SubscriptionTypes.NON_PII) {
          this.DeployServicesNonPii = true;
          const component  = [];
          component.push();
          this.serviceNonPii.forEach(element => {
            if(element.selected === true) {
             component.push(element.response);
            }
           });
          const nonPiiData: any = {
            tenantId : this.tenantId,
            dataZone: 'nonpii',
            version: this.selectedValue ? this.selectedValue : this.currentVersion,
            components: component
          };
          this.tenantService.postTenantSharedServiceDetails(nonPiiData)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(nonPii => {
            this.serviceNonPii.forEach(element => {
              if(element.selected === true) {
               component.push(element.response);
              }
             });
             this.loadData(this.tenantId,false);
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.SHARED_SERVICES');
              const message = translate('VIEW_WORKFLOW.SHARED_SERVICES_DEPLOYED');
              this.toastrService.successMessage(message, title);
            }, 500);
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.SHARED_NON_PII_FAILED'),
            description: errorMessage
          }})
            this.isComponentLoading = false;
            this.DeployServicesNonPii = false;
          });
        } else {
          this.DeployServicesNewPii = true;
          const component  = [];
          this.serviceNewPii.forEach(element => {
           if(element.selected === true) {
            component.push(element.response);
           }
          });
          const newPiiData: any = {
            tenantId : this.tenantId,
            dataZone: 'pii',
            version: this.selectedValue ? this.selectedValue : this.currentVersion,
            components: component
          };
          this.tenantService.postTenantSharedServiceDetails(newPiiData)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(pii => {
            this.serviceNewPii.forEach(element => {
              if(element.selected === true) {
               component.push(element.response);
              }
             });
             this.loadData(this.tenantId,false);
            setTimeout(() => {
              const title = translate('ERROR_DIALOG.PII_SHARED_SERVICES');
              const message = translate('ERROR_DIALOG.DEPLOYMENT_REQUEST');
              this.toastrService.successMessage(message, title);
            }, 500);
            this.loadInstances();
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.SHARED_PII_FAILED'),
            description: errorMessage
          }})
            this.isComponentLoading = false;
            this.DeployServicesNewPii = false;
          });
          this.DeployServicesNewPii = false;
        }
      }
    });
  }

  reDeploy(data): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('TENANT_DETAILS.EDGE_TITLE'),
        message: translate('VERSIONS.REDEPLOY_SUBTITLE'),
        confirmButtonText: translate('DIALOG.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.instanceService.redeployInstance(data?.instanceId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((instanceData: any) => {
              data.instanceDetails = instanceData;
              data.status = instanceData.status;
              this.loadData(this.tenantId, false);
            },(error)=>{
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.REDEPLOY_FAILED'),
                      description: errorMessage
                    }
              });
            }
          );
        }
      });
  }

  private startStopConfig(instance, event): void {
    event.stopPropagation();
  }

  validateInstances(instance?: Instance, key?: string): void {
    if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
      this.changeInstanceStatus(instance, key);
    } else if (this.instanceList?.length !== 0) {
      if (key === 'nonpii' || 'nonprod') {
        const instancesToCheck = this.instanceList?.filter(item => item.dataZone === DataZone.DEVELOPMENT);
        if (instancesToCheck.some(item => item.status !== DeployStatus.STOPPED)) {
          this.openErrorDialog(key === 'nonpii' ? 'TENANT_DETAILS.INSTANCES_SHAREDSERV_NONPII' : 'TENANT_DETAILS.INSTANCES_SHAREDSERV_NONPROD');
        } else {
          this.changeInstanceStatus(instance, key);
        }
      } else if (key === 'pii') {
        const instancesToCheck = this.instanceList?.filter(item => item.dataZone === DataZone.SECURE);
        if (instancesToCheck.some(item => item.status !== DeployStatus.STOPPED)) {
          this.openErrorDialog('TENANT_DETAILS.INSTANCES_SHAREDSERV_PII');
        } else {
          this.changeInstanceStatus(instance, key);
        }
      }
    } else {
      this.changeInstanceStatus(instance, key);
    }
  }

  openErrorDialog(description): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('BLUEPRINT_SUMMARY.VALIDATION_ERROR'),
        description: translate(description)
      }
    });
  }

  changeInstanceStatus(instance?: Instance, key?: string): void {
    if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_START_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_START_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.instanceService.instanceStart(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.tenantDetailsData.sharedServices[key].instanceDetails = data;
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.INSTANCE');
              const message = translate('INSTANCE_DETAILS.INSTANCE_START_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.INSTANCE_START_FAILED'),
                    description: errorMessage,
                  }
               })
              });
          }
      });
    } else {

      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_STOP_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_STOP_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.instanceService.instanceStop(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.tenantDetailsData.sharedServices[key].instanceDetails = data;
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.INSTANCE');
              const message = translate('INSTANCE_DETAILS.INSTANCE_STOP_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.INSTANCE_STOP_FAILED'),
                description: errorMessage
              }
            });
                });
          }
      });
    }
  }

  displayInstanceStatus(status?: any): string {
    if (status === DeployStatus.STOPPED || status === DeployStatus.START_FAILED || status === DeployStatus.STOPPING) {
      return 'Start';
    } else {
      return 'Stop';
    }
  }

  isInprogressStatus(status): any {
    return this.INSTANCE_DEPLOYING_STATES.includes(status);
  }

  accessInstanceMenu(instance): any {
    return (instance?.status !== DeployStatus.FAILED && instance?.status !== DeployStatus.TERMINATED && instance?.instanceClass !== this.instanceClass.A);
  }


  navigateToSolution(id): void {
    localStorage.setItem('tenantViewSolutionName', this.solutionName);
    this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenantId,RouterSegments.SOLUTION, id, 'versions']);
  }

  goToInstanceSummary(instance) {
    if (instance?.id) {
      this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
      this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenantId, RouterSegments.BLUEPRINTS, instance.blueprintId, RouterSegments.ENVIRONMENT, instance.id]);
    }
  }

  viewDetails(envt): void {
    this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenantId, RouterSegments.SHARED_SERVICES, envt]);
  }

  searchChanged(value): void {
    this.solutionVersions = this.versions.filter(item => item?.toLowerCase().startsWith(value.toLowerCase()));
  }
/**
 * Clear search text and reset options when dropdown closes
 */
resetDropdown() {
  this.searchValue = '';
  this.solutionVersions = [...this.versions];
}

// defaulting Temn monitor in prod tss from "202601" release version
modifyOptionalComponent(value) : void {
  if ( this.accountIdProdPii || this.subscriptionIdPii) {
    this.servicePii.forEach(item => {
      if (item.value === 'Temn Monitor') {
        if (this.compareVersions(value) >= 0) {
          item.selected = true;
          item.default = true;
        } else {
          item.selected = false;
          item.default = false;
        }
      }
    });
  }
  this.sortServiceComponents(this.servicePii);
}

compareVersions(value: String): number {
  const minVersion = "202601.0.0";
  const version1 = value.split('.').map(Number);
  const version2 = minVersion.split('.').map(Number);
  const len = Math.max(version1.length, version2.length);

  for (let i = 0; i < len; i++) {
    const x = version1[i] || 0;
    const y = version2[i] || 0;
    if (x > y) return 1;
    if (x < y) return -1;
  }
  return 0; 
}

  // Orders components as: mandatory → selected optional → unselected optional
  sortServiceComponents(components: any[]): void {
    components.sort((a, b) => {
      if (a.mandatory !== b.mandatory) return a.mandatory ? -1 : 1;
      if (a.default !== b.default) return a.default ? -1 : 1;
      return 0;
    });
  }

  /**
   * Prepares solution capabilities mappings for each version.
   * @param data 
   */
  prepareComponents(data: any) {
    data.forEach((value: any) => {
      let components: any = [];
      let optionalCompCount = 0;
      value.capabilities.forEach((item: any) => {
        const isMandatory = item.required === "mandatory";
        const isSystem = item.required === "system";
        if (!isMandatory && !isSystem) { optionalCompCount++; }
        if(!isSystem){
        components.push({
          value: item.displayName,
          response: item.name,
          selected: false,
          default: isMandatory,
          mandatory: isMandatory,
        });
      }
      });
      components.sort((a, b) => (a.mandatory === b.mandatory ? 0 : a.mandatory ? -1 : 1));
      this.solutionComponents.push({ version: value.version, component: components, optionalCompCount: optionalCompCount });
    })
  }

  /**
   * Updates component lists based on selected solution version.
   * @param version 
   */
  modifyComponents(version: any) {
    if (isSolutionVersion(version) && version !== "") {
      this.isLowerVersion = false;
      const matchedVersion = this.solutionComponents.find((item: any) => item.version === version);
      if (matchedVersion) {
        this.servicePii = matchedVersion.component.map(comp => ({ ...comp }));
        this.serviceNewPii = matchedVersion.component.map(comp => ({ ...comp }));
        this.serviceNonPii = matchedVersion.component.map(comp => ({ ...comp }));
        this.optionalComponentCount = matchedVersion.optionalCompCount;
      }
    } else {
      this.isLowerVersion = true;
      this.servicePii = this.defaultComponents.map(comp => ({ ...comp }));
      this.serviceNewPii = this.defaultComponents.map(comp => ({ ...comp }));
      this.serviceNonPii = this.defaultComponents.map(comp => ({ ...comp }));
    }
  }

   /**
   * Updates components using tenant optional component data.
   */
  applyTenantOptionalComponents() {
    this.modifyOptionalComponent(this.currentVersion);
    if (this.tenantDetailsData?.sharedServices?.prod?.optionalComponents?.length > 0) {
      this.servicePii?.filter((item) => {
        this.tenantDetailsData?.sharedServices?.prod?.optionalComponents.filter((component) => {
          if (item.response === component) {
            item.default = true;
            item.selected = false;
          }
        });
      });
      this.servicePiiFalseCount = this.servicePii.filter(item => item.default === false).length;
    }
    if (this.tenantDetailsData?.sharedServices?.nonprod?.optionalComponents?.length > 0) {
      this.serviceNonPii?.filter((item) => {
        this.tenantDetailsData?.sharedServices?.nonprod?.optionalComponents.filter((component) => {
          if (item.response === component) {
            item.default = true;
            item.selected = false;
          }
        });
      });
      this.serviceNonPiiFalseCount = this.serviceNonPii.filter(item => item.default === false).length;
    }
    if (this.tenantDetailsData?.sharedServices?.nonpii?.optionalComponents?.length > 0) {
      this.serviceNonPii?.filter((item) => {
        this.tenantDetailsData?.sharedServices?.nonpii?.optionalComponents.filter((component) => {
          if (item.response === component) {
            item.default = true;
            item.selected = false;
          }
        });
      });
      this.serviceNewNonPiiFalseCount = this.serviceNonPii.filter(item => item.default === false).length;
    }
    if (this.tenantDetailsData?.sharedServices?.pii?.optionalComponents?.length > 0) {
      this.serviceNewPii?.filter((item) => {
        this.tenantDetailsData?.sharedServices?.pii?.optionalComponents.filter((component) => {
          if (item.response === component) {
            item.default = true;
            item.selected = false;
          }
        });
      });
      this.serviceNewPiiFalseCount = this.serviceNewPii.filter(item => item.default === false).length;
    }
    this.sortServiceComponents(this.servicePii);
    this.sortServiceComponents(this.serviceNewPii);
    this.sortServiceComponents(this.serviceNonPii);
  }

  //verifies the condition to show details
  checkforViewDetails(){
      const sharedServices = this.tenantDetailsData?.sharedServices;
      if (this.shouldShowDetails(sharedServices?.nonpii?.optionalComponents)) {
        sharedServices.nonpii.showDetails = true;
      }
      if (this.shouldShowDetails(sharedServices?.nonprod?.optionalComponents)) {
        sharedServices.nonprod.showDetails = true;
      }
      if (this.shouldShowDetails(sharedServices?.pii?.optionalComponents)) {
        sharedServices.pii.showDetails = true;
      }
      if (this.shouldShowDetails(sharedServices?.prod?.optionalComponents)) {
        sharedServices.prod.showDetails = true;
      }
  }

  //Shows the view details button by checking for external MQ component based on selected version
  shouldShowDetails(optionalComponents: string[] = []): boolean {
    const componentName = this.isLowerVersion
      ? 'external_messaging'
      : 'tss-external-messaging';
    return optionalComponents.includes(componentName);
  }
}


